class SwiperRecommentElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this.querySelector(".cart-recomment"), {
      slidesPerView: "auto",
      spaceBetween: 8,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 237
      },
      mousewheel: {
        forceToAxis: true,
      },
    });
  }
}

customElements.define('cart-recomment', SwiperRecommentElement);